import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '@softapps/core/grid';
import { SubGroup } from './sub-group';

@Component({
  selector: 'soft-sub-group-column',
  imports: [],
  template: `
    <div class="flex flex-col">
      <span class="soft-overline !mb-0">{{ value()?.artuntergrp }}</span>
      <span class="text-sm">{{ value()?.bezeichnung }}</span>
    </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubGroupColumnComponent<TRow extends object> extends GridCellRenderer<TRow, SubGroup>{

}
